module.exports = __webpack_public_path__ + "static/img/yearly-card.1d992b1.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/imgs/payment/yearly-card.png
// module id = 2wgY
// module chunks = 1